declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_simple_string_foo extends $mol_object {
		hardcoded( ): string
		localized( ): string
	}
	
}

//# sourceMappingURL=simple_string.view.tree.d.ts.map